import { FC } from "react";
import AppUploadImage, { AppUploadImageProps } from "./../AppUploadImage";
import { Item, ItemProps } from ".";

interface UploadImageBaseProps extends ItemProps {
    height?: number | string;
    width?: number | string;
    minHeight?: number | string;
    imageClassName?: string;
};

const UploadImage: FC<UploadImageBaseProps & AppUploadImageProps> = (props) => {

    const { col, error, label, required, itemClassName } = props;

    return (
        <Item col={col} label={label} required={required} error={error} itemClassName={itemClassName}>
            {props.multiple ? (
                <AppUploadImage
                    multiple
                    value={props.value || []}
                    onChange={props.onChange}
                    height={props.height}
                    width={props.width}
                    minHeight={props.minHeight}
                    imageClassName={props.imageClassName}
                />
            ) : (
                <AppUploadImage
                    value={props.value || ""}
                    onChange={props.onChange}
                    height={props.height}
                    width={props.width}
                    minHeight={props.minHeight}
                    imageClassName={props.imageClassName}
                />
            )}
        </Item>
    )
}
export default UploadImage;